module.exports = __webpack_public_path__ + "img/0-lg.db61a167.jpg";